import axios, { AxiosRequestConfig } from 'axios';
// config
import { HOST_API } from 'src/config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API });

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
  chat: '/api/chat',
  kanban: '/api/kanban',
  calendar: '/api/calendar',
  auth: {
    me: '/distributor/info',
    login: '/api/auth/login',
    register: '/api/auth/register',
  },
  mail: {
    list: '/api/mail/list',
    details: '/api/mail/details',
    labels: '/api/mail/labels',
  },
  post: {
    list: '/api/post/list',
    details: '/api/post/details',
    latest: '/api/post/latest',
    search: '/api/post/search',
  },
  product: {
    list: '/api/product/list',
    details: '/api/product/details',
    search: '/api/product/search',
  },
  retailers: {
    list: '/distributor/retailers',
    add: 'distributor/retailers',
    update: 'distributor/retailers',
    updateLeads: 'distributor/retailers/new-leads',
    getOnboardingHistory: '/distributor/retailers/history',
  },
  cpv: {
    list: '/distributor/cpv',
    execute: 'distributor/cpv',
    update: 'distributor/cpv',
    check: '/distributor/cpv/individual',
    checkPrice: '/distributor/cpv/balance_check',
  },
  enquiry: {
    list: '/distributor/enquiry',
  },
  distributors: {
    info:'/distributor',
    list: '/aggregator/distributor',
    add: 'aggregator/distributor',
    update: 'aggregator/distributor',
    updateLeads: 'aggregator/distributor/new-leads',
    getOnboardingHistory: '/aggregator/distributor/history',
  },
  catalogue: {
    details: '/catalogue',
    list: '/distributor/catalogue',
    add: 'distributor/catalogue',
    fileUploadUrl: 'distributor/catalogue/file-upload',
    update: 'distributor/catalogue',
    history: '/distributor/catalogue/history',
  },
  upload: {
    fetchUrl: '/distributor/upload',
    processUpload: 'distributor/upload',
    downloadTemplate: '/distributor/templates',
  },
  prepaid: {
    statement: '/distributor/prepaid/statement',
    newRequest: 'distributor/prepaid/recharge',
    updateRequest: 'distributor/prepaid/recharge',
  },
  orders: {
    list: '/distributor/order',
    add: 'distributor/order',
  },
  invoice: {
    list: '/distributor/invoice',
  },
};
